import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Container,
    Content,
    Title,
} from "./style";
import {
    Card,
    CardContent,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@mui/material";
import {
    Visibility,
} from "@mui/icons-material";
import moment from "moment";
import { Error } from "../Error";
import { Header } from "../Header";
import { apiOperation, apiAutenticacao, headers } from "../../services/api";
import { AnaliseSimples, Listar, Documento } from "../../models/analise";
import { cnpjMask, cnpjOrCpfMask } from "../../utils/mask";
import { Loading } from "../Loading";
import { getSessionUser } from "../../utils/users";
import { IUser } from "../Login/ILogin";
import { Empresas } from "../../utils/empresa";

let usuarioLogado: IUser | null = null;

export const AppPreview = () => {
    const navigate = useNavigate();
    const [historyList, setHistoryList] = useState<AnaliseSimples[]>([]);
    const [showLoading, setShowLoading] = useState(true);
    const [carregarItensJnsSeguradora, setCarregarItensJnsSeguradora] = useState(false);
    const [pagination, setPagination] = useState({
        paginaCorrente: 0,
        quantidadePaginas: 0,
        tamanhoPagina: 10,
        quantidadeRegistros: 0,
    });

    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [errorApi, setErrorApi] = useState({
        message: "",
        title: "",
        state: false,
    });

    const hasAnalysisData = historyList.some(item => item.seguimento);

    const handleChangeRowsPerPage = (event: any) => {
        setRecordsPerPage(event.target.value);
        setPagination({
            ...pagination,
            paginaCorrente: 0,
            tamanhoPagina: event.target.value | 10,
        });
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPagination({
            ...pagination,
            paginaCorrente: newPage,
        });
    };

    const getHistory = async (params = "") => {
        try {
            const config = {
                headers: headers(),
            };
            setShowLoading(true);
        
            let urlString = `esteira/listar
				?pagina=${pagination.paginaCorrente}
				&registrosPorPagina=${pagination.tamanhoPagina}`;

            urlString += params;
            const { data } = await apiOperation.get<Listar>(urlString, config);

            if (!data.erro) {
                setHistoryList([...data.valor.dados]);
                setPagination({
                    ...pagination,
                    quantidadePaginas: data.valor.quantidadePaginas,
                    quantidadeRegistros: data.valor.quantidadeRegistros,
                });
                setShowLoading(false);
            } else {
                setErrorApi({
                    title: "Não foi possivel se conectar a API no momento.",
                    state: true,
                    message: data.erros?.join("<hr />"),
                });
                setShowLoading(false);
            }
        } catch (error: any) {
            setErrorApi({
                title: `API Não disponivel`,
                message: `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`,
                state: true,
            });
            setShowLoading(false);
        }
    };

    const Download = async (params = "") => {
        try {
            const config = {
                headers: headers(),
            };

            setShowLoading(true);
            let urlString = `analise/relatorio
				?analiseId=${params}`;

            const { data } = await apiOperation.get<Documento>(urlString, config);

            window.open(data.valor, "_blank", "noopener,noreferrer");

            setShowLoading(false);
        } catch (error: any) {
            setErrorApi({
                title: `API Não disponivel`,
                message: `Falha ao baixar relatório!`,
                state: true,
            });
            setShowLoading(false);
        }
    };

    useEffect(() => {
        getHistory();
    }, [pagination.paginaCorrente, pagination.tamanhoPagina]);

    return (
        <>
            <Header />
            <Container>
                <Content>
                    <Title>Análises em Esteira</Title>
                </Content>
                <Card sx={{ minWidth: 275 }}>
                    {showLoading ? (
                        <Loading hidden={!showLoading} />
                    ) : (
                        <>
                            <CardContent>
                                <TableContainer>
                                    <Table
                                        sx={{ minWidth: 650 }}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">CNPJ</TableCell>
                                                {hasAnalysisData && <TableCell align="left">Tipo</TableCell>}
                                                <TableCell align="left">Solicitante</TableCell>
                                                <TableCell align="left">Data da Consulta</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Relatório</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {historyList.map((item) => (
                                                <TableRow
                                                    key={item.analiseId}
                                                    sx={{
                                                        "&:last-child td, &:last-child th": { border: 0 },
                                                    }}
                                                    hover
                                                >
                                                    <TableCell align="left">
                                                        {cnpjMask(item.cnpjOuCpf)}
                                                    </TableCell>
                                                    {hasAnalysisData && <TableCell align="left">{item.seguimento}</TableCell>}
                                                    <TableCell align="left">
                                                        {item.usuarioInclusao}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {moment(item.dataInclusao).format("DD/MM/YYYY")}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ whiteSpace: "break-spaces" }}
                                                    >
                                                        <div
                                                            style={{
                                                                backgroundColor:
                                                                    item.status === "Concluída"
                                                                        ? "var(--success)"
                                                                        : item.status === "Processando"
                                                                            ? "var(--info)"
                                                                            : item.status === "Análise em esteira"
                                                                                ? "var(--warning)"
                                                                                : "var(--error)",
                                                                borderRadius: "15px",
                                                                width: "fit-content",
                                                                padding: "inherit",
                                                                color: "var(--text-on-inverse)",
                                                                margin: "auto",
                                                            }}
                                                        >
                                                            {item.status}
                                                        </div>
                                                    </TableCell>
                                                        <TableCell align="center">
                                                            <IconButton
                                                                onClick={() =>
                                                                    navigate(`/Visualization/${item.analiseId}`)
                                                                }
                                                                color="primary"
                                                                aria-label="Visualizar"
                                                            >
                                                                <Visibility />
                                                            </IconButton>
                                                        </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={pagination.quantidadeRegistros}
                                        page={pagination.paginaCorrente}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={recordsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage={"Registros Por Páginas: "}
                                    />
                                </TableContainer>
                            </CardContent>
                        </>
                    )}
                </Card>
                <Error
                    hasOpen={errorApi.state}
                    handleClose={() => setErrorApi({ ...errorApi, state: false })}
                    errorMsg={errorApi.message}
                    title={errorApi.title}
                />
            </Container>
        </>
    );
};
